<script>
export default {
  props: {
    defaultValue: { type: String, default: '' },
    buttonText: {
      type: String,
      default: function () {
        return this.$t('general.save');
      },
    },
    title: { type: String, default: '' },
  },
  data() {
    return {
      newValue: '',
    };
  },
  methods: {
    modalHidden() {
      this.newValue = '';
      this.$emit('modal-closed');
    },
    save() {
      this.$emit('save', this.newValue);
      this.$bvModal.hide('value-change-modal');
    },
    modalShown() {
      this.newValue = this.defaultValue;
      this.$refs.inputNewValue.focus();
    },
  },
};
</script>

<template>
  <div>
    <b-modal
      id="value-change-modal"
      size="lg"
      @shown="modalShown()"
      @hide="modalHidden()"
      ok-variant="primary"
      no-close-on-backdrop
    >
      <b-form-input
        type="text"
        v-model="newValue"
        ref="inputNewValue"
        @keydown.enter.prevent="save()"
      >
      </b-form-input>
      <template #modal-footer>
        <b-button
          @click="$bvModal.hide('value-change-modal')"
          size="md"
          variant="secondary"
        >
          {{ $t('general.cancel') }}
        </b-button>
        <b-button @click="save()" size="md" variant="primary">
          {{ buttonText }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>